import { Component, Input } from '@angular/core';
import { Patient } from '../models/patient';
import { TuiIcon } from '@taiga-ui/core';
import { TuiChip } from '@taiga-ui/kit';

@Component({
  selector: 'app-dossier-title-group',
  standalone: true,
  imports: [TuiIcon, TuiChip],
  templateUrl: './patient-title-group.component.html',
  styleUrl: './patient-title-group.component.scss',
})
export class PatientTitleGroupComponent {
  @Input() patient: Patient | undefined;
  @Input() activite: string | undefined;
  @Input() enCoursDeChargement: boolean = false;
}
